import React from "react"
import i18n from "@/utils/i18n"
import ErrorPage from "../ErrorPage"

const UnauthorizedPage: React.FC = () => {
  return (
    <ErrorPage
      errorCode="403"
      titleKey="errors.unauthorized.title"
      titleDefault={i18n.t("errors.unauthorized.title")}
      descriptionKey="errors.unauthorized.description"
      descriptionDefault={i18n.t("errors.unauthorized.description")}
      buttonKey="errors.unauthorized.goToDashboard"
      buttonDefault={i18n.t("errors.unauthorized.goToDashboard")}
      titleSize="6rem"
    />
  )
}

export default UnauthorizedPage